import React from "react";
import { motion, useAnimation } from "framer-motion";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import { useForm, ValidationError } from "@formspree/react";
import { Link } from "react-router-dom";

const Contact = () => {
  const currentYear = new Date().getFullYear();

  const control = useAnimation();

  const [state, handleSubmit, reset] = useForm("xlekpvge");
  const [showThanksMessage, setShowThanksMessage] = React.useState(false);

  const onSubmit = (data) => {
    handleSubmit(data);
    if (state.succeeded) {
      reset();
      setShowThanksMessage(true);
      setTimeout(() => {
        setShowThanksMessage(false);
      }, 4000); // set the time for 5 seconds
    }
  };

  React.useEffect(() => {
    if (state.succeeded) {
      setShowThanksMessage(true);
      setTimeout(() => {
        setShowThanksMessage(false);
      }, 4000); // set the time for 5 seconds
    }
  }, [state.succeeded]);

  if (showThanksMessage) {
    return (
      <div className="contact-section">
        <div className="contact-thankyou">
          <h1 className="thankyou-page">
            Thank you for your email! I'll get back to you as soon as possible.
            🏃‍♂️💨
          </h1>
        </div>
      </div>
    );
  }

  return (
    <div className="contact-section">
      <motion.h1
        className="contact-heading"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        Contact<span className="contact-dot">.</span>
      </motion.h1>

      <motion.div
        className="contact-wrapper"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, ease: "easeOut", delay: 0.2 }}
      >
        <div className="contact-bg-card">
          <h2 className="contact-info-title">Let's Work Together</h2>
          <p className="contact-info-text">
            Have a question or want to collaborate? Send me a message. <br></br>{" "}
            I'll get back to you as soon as possible.
          </p>
          <p className="contact-info-text contact-spanish">Se Habla Español.</p>

          <div className="contact-socials">
            <a
              href="https://github.com/tito3288"
              className="contact-social-link"
            >
              <GitHubIcon className="contact-social-icon" />
            </a>
            <a
              href="https://www.linkedin.com/in/bryan-arambula-823a86191/"
              className="contact-social-link"
            >
              <LinkedInIcon className="contact-social-icon" />
            </a>
            <a
              href="https://www.facebook.com/bryan.josepharambula"
              className="contact-social-link"
            >
              <FacebookIcon className="contact-social-icon" />
            </a>
            <a
              href="https://www.instagram.com/vinda_lavida/"
              className="contact-social-link"
            >
              <InstagramIcon className="contact-social-icon" />
            </a>
          </div>

          <Link to="/privacy" className="privacy-policy-link">
            Privacy Policy
          </Link>
        </div>

        <div className="contact-floating-form">
          <form onSubmit={onSubmit}>
            <input
              id="name"
              type="text"
              name="name"
              className="contact-input"
              placeholder="Name"
            />
            <ValidationError prefix="Name" field="name" errors={state.errors} />

            <input
              id="email"
              type="email"
              name="email"
              className="contact-input"
              placeholder="Email"
            />
            <ValidationError
              prefix="Email"
              field="email"
              errors={state.errors}
            />

            <input
              id="subject"
              type="text"
              name="subject"
              className="contact-input"
              placeholder="Subject"
            />
            <ValidationError
              prefix="Subject"
              field="subject"
              errors={state.errors}
            />

            <textarea
              id="message"
              name="message"
              className="contact-textarea"
              placeholder="Enter Message"
            />
            <ValidationError
              prefix="Message"
              field="message"
              errors={state.errors}
            />

            <motion.div animate={control} transition={{ duration: 0.5 }}>
              <button
                type="submit"
                className="contact-submit-btn"
                onClick={() => control.start({ scale: [1.1, 1] })}
                disabled={state.submitting}
              >
                {state.submitting ? "Sending..." : "Send Message"}
              </button>
            </motion.div>
          </form>
        </div>
      </motion.div>

      <div className="contact-footer">
        <p className="contact-footer-text">
          Bryan Arambula &copy; {currentYear}
        </p>
      </div>
    </div>
  );
};

export default Contact;
